export default __webpack_public_path__ + "static/media/simple drum_1.ef187303.wav";